export default __webpack_public_path__ + "static/media/gallery-6-1.dfa56c00.jpg";